import { ActionRow, ConfiguredColumn } from '@types'

export const findColumnsByIds = (
  columnIds: (string | number)[] | undefined,
  columns: ConfiguredColumn[] = []
): ConfiguredColumn[] => {
  if (!columnIds?.length) {
    return []
  }

  return columnIds
    .map(columnId =>
      columns.find(
        column =>
          String(column.id) === String(columnId) ||
          String(column.internalId) === String(columnId)
      )
    )
    .filter((column): column is ConfiguredColumn => Boolean(column))
}

export const getActionTargetColumnTitles = (
  action: ActionRow,
  columns: ConfiguredColumn[] = []
): string => {
  if (action.target?.title) {
    return action.target.title
  }

  return findColumnsByIds(action.columnIds, columns)
    .map(column => column.title)
    .join(', ')
}

export const enrichViewActionWithTargetColumns = (
  action: ActionRow,
  columns: ConfiguredColumn[] = []
): ActionRow => {
  const matchedColumns = findColumnsByIds(action.columnIds, columns)

  if (!matchedColumns.length) {
    return action
  }

  const title = getActionTargetColumnTitles(action, columns)

  return {
    ...action,
    target: {
      ...(action.target ?? matchedColumns[0]),
      title,
    },
  }
}
